import { createContext } from 'react';
import type { FieldcoreDb } from '../db/database';
import type { AgendaRefresher } from '../planning/refresh';
import type { FieldRuntime } from './fieldRuntime';
import type { GeoService } from '../geo/service';
import type { InstallService } from './install';
import type { SessionManager } from '../session/manager';
import type { SyncEngine } from '../sync/engine';
import type { PhotoQueue } from '../sync/photoQueue';

export interface AppRuntime {
  db: FieldcoreDb;
  session: SessionManager;
  engine: SyncEngine;
  geo: GeoService;
  /** INC-05b: the photo upload queue. */
  photos: PhotoQueue;
  /** D-208: what this device can do about installing the application. */
  install: InstallService;
  /** D-225: the agenda that reads itself again on its own. */
  agenda: AgendaRefresher;
  /** D-83: what starts the pieces above for the field's role and no other. */
  field: FieldRuntime;
}

export const RuntimeContext = createContext<AppRuntime | null>(null);
